import { IComboBoxOption } from "@fluentui/react/lib";
import { List } from "linq.ts";

export enum ControlType {
    undefined = 0,
    row = 1,
    subtitle = 2,
    textField = 3,
    comboBox = 4,
    checkBox = 6,
    button = 7,
    dataTable = 8,
    numericTextField = 9,
    datePicker = 10,
    object = 11,
    label = 12,
    checkBoxList = 13,
    documentUploader = 14,
    pivot = 15,
    chart = 16,
    calculatedValue = 17,
    component = 18,
    expedienteSelector = 19,
    documentaryTypeSelector = 20,
    documentaryTypeMetadataEditor = 21,
    scheduler = 22,
    radicadoEntradaSelector = 23,
    timePicker = 24,
    searchableComboBox = 25,
    citySelector = 26,
    userSelector = 27,
    dateTimePicker = 28,
    decimalField = 29,
    currencyField = 30,
    sectionSelector = 31,
    radicadoSalidaViewer = 32,
    radicadoEntradaViewer = 33,
    countrySelector = 34,
    departmentSelector = 35,
    title = 36,
    image = 37,
    video = 38,
    clientComponent = 39,
    groupedDataGrid = 40,
    /**
     * Control especializado en la consulta de registros de una entidad de ProcesoX
     */
    entityDataTable = 41,
    horizontalLine = 42,
    card = 43,
    commandBar = 44,
}

export const ControlTypeDataSource: IComboBoxOption[] = new List<IComboBoxOption>([
    { key: ControlType.button, text: `${ControlType[ ControlType.button ]} [${ControlType.button}]` },
    { key: ControlType.calculatedValue, text: `${ControlType[ ControlType.calculatedValue ]} [${ControlType.calculatedValue}]` },
    { key: ControlType.chart, text: `${ControlType[ ControlType.chart ]} [${ControlType.chart}]` },
    { key: ControlType.checkBox, text: `${ControlType[ ControlType.checkBox ]} [${ControlType.checkBox}]` },
    { key: ControlType.checkBoxList, text: `${ControlType[ ControlType.checkBoxList ]} [${ControlType.checkBoxList}]` },
    { key: ControlType.citySelector, text: `${ControlType[ ControlType.citySelector ]} [${ControlType.citySelector}]` },
    { key: ControlType.clientComponent, text: `${ControlType[ ControlType.clientComponent ]} [${ControlType.clientComponent}]` },
    { key: ControlType.comboBox, text: `${ControlType[ ControlType.comboBox ]} [${ControlType.comboBox}]` },
    { key: ControlType.component, text: `${ControlType[ ControlType.component ]} [${ControlType.component}]` },
    { key: ControlType.countrySelector, text: `${ControlType[ ControlType.countrySelector ]} [${ControlType.countrySelector}]` },
    { key: ControlType.currencyField, text: `${ControlType[ ControlType.currencyField ]} [${ControlType.currencyField}]` },
    { key: ControlType.dataTable, text: `${ControlType[ ControlType.dataTable ]} [${ControlType.dataTable}]` },
    { key: ControlType.datePicker, text: `${ControlType[ ControlType.datePicker ]} [${ControlType.datePicker}]` },
    { key: ControlType.dateTimePicker, text: `${ControlType[ ControlType.dateTimePicker ]} [${ControlType.dateTimePicker}]` },
    { key: ControlType.decimalField, text: `${ControlType[ ControlType.decimalField ]} [${ControlType.decimalField}]` },
    { key: ControlType.departmentSelector, text: `${ControlType[ ControlType.departmentSelector ]} [${ControlType.departmentSelector}]` },
    { key: ControlType.documentaryTypeMetadataEditor, text: `${ControlType[ ControlType.documentaryTypeMetadataEditor ]} [${ControlType.documentaryTypeMetadataEditor}]` },
    { key: ControlType.documentaryTypeSelector, text: `${ControlType[ ControlType.documentaryTypeSelector ]} [${ControlType.documentaryTypeSelector}]` },
    { key: ControlType.documentUploader, text: `${ControlType[ ControlType.documentUploader ]} [${ControlType.documentUploader}]` },
    { key: ControlType.expedienteSelector, text: `${ControlType[ ControlType.expedienteSelector ]} [${ControlType.expedienteSelector}]` },
    { key: ControlType.image, text: `${ControlType[ ControlType.image ]} [${ControlType.image}]` },
    { key: ControlType.label, text: `${ControlType[ ControlType.label ]} [${ControlType.label}]` },
    { key: ControlType.numericTextField, text: `${ControlType[ ControlType.numericTextField ]} [${ControlType.numericTextField}]` },
    { key: ControlType.object, text: `${ControlType[ ControlType.object ]} [${ControlType.object}]` },
    { key: ControlType.pivot, text: `${ControlType[ ControlType.pivot ]} [${ControlType.pivot}]` },
    { key: ControlType.radicadoEntradaSelector, text: `${ControlType[ ControlType.radicadoEntradaSelector ]} [${ControlType.radicadoEntradaSelector}]` },
    { key: ControlType.radicadoEntradaViewer, text: `${ControlType[ ControlType.radicadoEntradaViewer ]} [${ControlType.radicadoEntradaViewer}]` },
    { key: ControlType.radicadoSalidaViewer, text: `${ControlType[ ControlType.radicadoSalidaViewer ]} [${ControlType.radicadoSalidaViewer}]` },
    { key: ControlType.scheduler, text: `${ControlType[ ControlType.scheduler ]} [${ControlType.scheduler}]` },
    { key: ControlType.searchableComboBox, text: `${ControlType[ ControlType.searchableComboBox ]} [${ControlType.searchableComboBox}]` },
    { key: ControlType.sectionSelector, text: `${ControlType[ ControlType.sectionSelector ]} [${ControlType.sectionSelector}]` },
    { key: ControlType.subtitle, text: `${ControlType[ ControlType.subtitle ]} [${ControlType.subtitle}]` },
    { key: ControlType.textField, text: `${ControlType[ ControlType.textField ]} [${ControlType.textField}]` },
    { key: ControlType.timePicker, text: `${ControlType[ ControlType.timePicker ]} [${ControlType.timePicker}]` },
    { key: ControlType.title, text: `${ControlType[ ControlType.title ]} [${ControlType.title}]` },
    { key: ControlType.userSelector, text: `${ControlType[ ControlType.userSelector ]} [${ControlType.userSelector}]` },
    { key: ControlType.video, text: `${ControlType[ ControlType.video ]} [${ControlType.video}]` },
    { key: ControlType.entityDataTable, text: `${ControlType[ ControlType.entityDataTable ]} [${ControlType.entityDataTable}]` },
    { key: ControlType.horizontalLine, text: `${ControlType[ ControlType.horizontalLine ]} [${ControlType.horizontalLine}]` },
    { key: ControlType.card, text: `${ControlType[ ControlType.card ]} [${ControlType.card}]` },
]).OrderBy(o => o.text)
    .Select(x => ({ ...x, text: x.text.replace(/([A-Z])/g, ' $1') }))
    .ToArray();
